module Tapas.Bindings {
    export class ImageLeftTextRight {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;
            
            const imageVerticallyText = $(".imageleft-textright.text-vertical-center");
            imageVerticallyText.parents(".imageleft-textright-wrapper").addClass("flex");
        }
    }
    ko.bindingHandlers['imagelefttextright'] = new ImageLeftTextRight();
}